"use client";

import { useState } from 'react';

export default function TransportationDashboardsSection() {
  const [activeTab, setActiveTab] = useState(0);

  const dashboards = [
    {
      title: 'EXECUTIVE OPERATIONS DASHBOARD',
      subtitle: 'Transportation Executive Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Transportation Executive Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards */}
          {[
            { x: 16, label: 'Fleet Utilization', value: '82%', sub: '+4.2% MoM', color: '#C5A572' },
            { x: 186, label: 'OTIF Performance', value: '94.2%', sub: 'Target: 95%', color: '#16a34a' },
            { x: 356, label: 'Cost per KM', value: '₹6.80', sub: '↓ ₹0.40 vs LY', color: '#1B2845' },
            { x: 526, label: 'Active Vehicles', value: '1,284', sub: '96 in maintenance', color: '#1B2845' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="76" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="18" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
              <text x={kpi?.x + 12} y="114" fill="#9ca3af" fontSize="9" fontFamily="sans-serif">{kpi?.sub}</text>
            </g>
          ))}

          {/* Fleet Utilization Trend */}
          <rect x="16" y="136" width="420" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Fleet Utilization Trend (%)</text>
          <polyline points="40,290 90,278 140,282 190,268 240,272 290,258 340,252 390,244 420,240" fill="none" stroke="#C5A572" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          <polyline points="40,290 90,278 140,282 190,268 240,272 290,258 340,252 390,244 420,240 420,310 40,310 Z" fill="#C5A572" opacity="0.06" />
          {[40,90,140,190,240,290,340,390,420]?.map((x, i) => (
            <circle key={i} cx={x} cy={[290,278,282,268,272,258,252,244,240]?.[i]} r="3" fill="#1B2845" />
          ))}
          {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep']?.map((m, i) => (
            <text key={i} x={[40,90,140,190,240,290,340,390,420]?.[i] - 8} y="308" fill="#9ca3af" fontSize="8" fontFamily="sans-serif">{m}</text>
          ))}

          {/* Operating Cost by Category */}
          <rect x="448" y="136" width="236" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="460" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Operating Cost Analysis</text>
          {[
            { label: 'Fuel', val: 180, color: '#dc2626', pct: '42%' },
            { label: 'Maintenance', val: 120, color: '#d97706', pct: '28%' },
            { label: 'Driver Costs', val: 80, color: '#1B2845', pct: '19%' },
            { label: 'Tolls & Misc', val: 46, color: '#C5A572', pct: '11%' },
          ]?.map((bar, i) => (
            <g key={i}>
              <text x="460" y={178 + i * 30} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{bar?.label}</text>
              <rect x="510" y={166 + i * 30} width={bar?.val} height="14" fill={bar?.color} rx="2" opacity="0.8" />
              <text x="516" y={178 + i * 30} fill="white" fontSize="8" fontWeight="bold" fontFamily="sans-serif">{bar?.pct}</text>
            </g>
          ))}

          {/* Revenue per Route Table */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Revenue per Route (Top Corridors)</text>
          <line x1="16" y1="352" x2="684" y2="352" stroke="#e5e7eb" strokeWidth="1" />
          {['Route', 'Distance', 'Revenue', 'OTIF', 'Status']?.map((h, i) => (
            <text key={i} x={28 + i * 130} y="364" fill="#6b7280" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{h}</text>
          ))}
          {[
            ['Mumbai–Pune', '150 km', '₹28Cr', '96.2%', '✓'],
            ['Delhi–Jaipur', '280 km', '₹22Cr', '93.8%', '✓'],
            ['Bangalore–Chennai', '350 km', '₹19Cr', '91.4%', '⚠'],
          ]?.map((row, i) => (
            <g key={i}>
              {row?.map((cell, j) => (
                <text key={j} x={28 + j * 130} y={380 + i * 14} fill={j === 4 ? (cell === '✓' ? '#16a34a' : '#d97706') : '#374151'} fontSize="9" fontFamily="sans-serif">{cell}</text>
              ))}
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'FLEET OPERATIONS DASHBOARD',
      subtitle: 'Vehicle & Fleet Performance Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Fleet Operations Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards */}
          {[
            { x: 16, label: 'Vehicle Availability', value: '89%', sub: '144 in service', color: '#16a34a' },
            { x: 186, label: 'Fuel Efficiency', value: '8.4 km/L', sub: '+0.6 vs target', color: '#C5A572' },
            { x: 356, label: 'Maintenance Alerts', value: '28', sub: '6 critical', color: '#dc2626' },
            { x: 526, label: 'Op Efficiency Score', value: '86%', sub: 'Above benchmark', color: '#1B2845' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="76" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="18" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
              <text x={kpi?.x + 12} y="114" fill="#9ca3af" fontSize="9" fontFamily="sans-serif">{kpi?.sub}</text>
            </g>
          ))}

          {/* Fleet Utilization by Vehicle Type */}
          <rect x="16" y="136" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Fleet Utilization by Vehicle Type</text>
          {[
            { label: 'Heavy Trucks', val: 175, color: '#1B2845', pct: '88%' },
            { label: 'Medium Trucks', val: 160, color: '#C5A572', pct: '84%' },
            { label: 'Light Vehicles', val: 145, color: '#3b82f6', pct: '79%' },
            { label: 'Refrigerated', val: 170, color: '#10b981', pct: '86%' },
            { label: 'Tankers', val: 155, color: '#8b5cf6', pct: '82%' },
          ]?.map((bar, i) => (
            <g key={i}>
              <text x="28" y={175 + i * 24} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{bar?.label}</text>
              <rect x="120" y={163 + i * 24} width={bar?.val} height="14" fill={bar?.color} rx="2" opacity="0.8" />
              <text x="126" y={175 + i * 24} fill="white" fontSize="8" fontWeight="bold" fontFamily="sans-serif">{bar?.pct}</text>
            </g>
          ))}

          {/* Maintenance Alerts */}
          <rect x="358" y="136" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Maintenance Alerts</text>
          {[
            { vehicle: 'TN-01-AB-1234 — Engine', priority: 'CRIT', color: '#dc2626', bg: '#fef2f2' },
            { vehicle: 'MH-12-CD-5678 — Brakes', priority: 'CRIT', color: '#dc2626', bg: '#fef2f2' },
            { vehicle: 'KA-09-EF-9012 — Tyres', priority: 'HIGH', color: '#d97706', bg: '#fffbeb' },
            { vehicle: 'DL-05-GH-3456 — Oil', priority: 'MED', color: '#d97706', bg: '#fffbeb' },
            { vehicle: 'GJ-18-IJ-7890 — Filter', priority: 'LOW', color: '#16a34a', bg: '#f0fdf4' },
          ]?.map((alert, i) => (
            <g key={i}>
              <rect x="370" y={163 + i * 28} width="302" height="22" rx="4" fill={alert?.bg} />
              <text x="380" y={178 + i * 28} fill="#374151" fontSize="9" fontFamily="sans-serif">{alert?.vehicle}</text>
              <rect x="628" y={165 + i * 28} width="32" height="18" rx="3" fill={alert?.color} opacity="0.15" />
              <text x="644" y={178 + i * 28} textAnchor="middle" fill={alert?.color} fontSize="8" fontWeight="bold" fontFamily="sans-serif">{alert?.priority}</text>
            </g>
          ))}

          {/* Fuel Consumption Trend */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Fuel Consumption Trend (Litres/Day)</text>
          <polyline points="50,395 130,385 210,390 290,378 370,382 450,370 530,365 620,358 680,352" fill="none" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <polyline points="50,395 130,385 210,390 290,378 370,382 450,370 530,365 620,358 680,352 680,400 50,400 Z" fill="#dc2626" opacity="0.04" />
          {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep']?.map((m, i) => (
            <text key={i} x={[50,130,210,290,370,450,530,620,680]?.[i] - 8} y="408" fill="#9ca3af" fontSize="8" fontFamily="sans-serif">{m}</text>
          ))}
        </svg>
      ),
    },
    {
      title: 'ROUTE & DELIVERY DASHBOARD',
      subtitle: 'Route Efficiency & Delivery Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Route & Delivery Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards */}
          {[
            { x: 16, label: 'On-Time Delivery', value: '94.2%', sub: 'OTIF Score', color: '#16a34a' },
            { x: 186, label: 'Avg Delivery Time', value: '4.2 hrs', sub: '↓ 0.3 hrs MoM', color: '#C5A572' },
            { x: 356, label: 'Route Efficiency', value: '91%', sub: 'vs optimal route', color: '#1B2845' },
            { x: 526, label: 'Delayed Deliveries', value: '142', sub: '5.8% of total', color: '#d97706' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="76" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="18" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
              <text x={kpi?.x + 12} y="114" fill="#9ca3af" fontSize="9" fontFamily="sans-serif">{kpi?.sub}</text>
            </g>
          ))}

          {/* Route Efficiency by Corridor */}
          <rect x="16" y="136" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Route Efficiency by Corridor</text>
          {[
            { label: 'Mumbai–Pune', val: 185, color: '#16a34a', pct: '96%' },
            { label: 'Delhi–Jaipur', val: 170, color: '#C5A572', pct: '92%' },
            { label: 'Blr–Chennai', val: 155, color: '#3b82f6', pct: '88%' },
            { label: 'Hyd–Vizag', val: 145, color: '#8b5cf6', pct: '84%' },
            { label: 'Kolkata–Patna', val: 130, color: '#d97706', pct: '78%' },
          ]?.map((bar, i) => (
            <g key={i}>
              <text x="28" y={175 + i * 24} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{bar?.label}</text>
              <rect x="110" y={163 + i * 24} width={bar?.val} height="14" fill={bar?.color} rx="2" opacity="0.8" />
              <text x="116" y={175 + i * 24} fill="white" fontSize="8" fontWeight="bold" fontFamily="sans-serif">{bar?.pct}</text>
            </g>
          ))}

          {/* Delivery Time Analysis */}
          <rect x="358" y="136" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Delivery Time Analysis (Avg Hours)</text>
          <polyline points="370,290 420,278 470,282 520,268 570,272 620,258 670,250" fill="none" stroke="#1B2845" strokeWidth="2" strokeLinecap="round" />
          <polyline points="370,290 420,278 470,282 520,268 570,272 620,258 670,250 670,310 370,310 Z" fill="#1B2845" opacity="0.04" />
          {['Mon','Tue','Wed','Thu','Fri','Sat','Sun']?.map((d, i) => (
            <text key={i} x={370 + i * 50} y="308" fill="#9ca3af" fontSize="8" fontFamily="sans-serif">{d}</text>
          ))}

          {/* Top Routes Performance Table */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Top Routes by Performance</text>
          <line x1="16" y1="352" x2="684" y2="352" stroke="#e5e7eb" strokeWidth="1" />
          {['Corridor', 'Deliveries', 'OTIF', 'Avg Time', 'Trend']?.map((h, i) => (
            <text key={i} x={28 + i * 130} y="364" fill="#6b7280" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{h}</text>
          ))}
          {[
            ['Mumbai–Pune', '284', '96.2%', '3.8 hrs', '↑'],
            ['Delhi–Jaipur', '198', '93.8%', '4.2 hrs', '→'],
            ['Blr–Chennai', '176', '91.4%', '5.1 hrs', '↓'],
          ]?.map((row, i) => (
            <g key={i}>
              {row?.map((cell, j) => (
                <text key={j} x={28 + j * 130} y={380 + i * 14} fill={j === 4 ? (cell === '↑' ? '#16a34a' : cell === '↓' ? '#dc2626' : '#6b7280') : '#374151'} fontSize="9" fontFamily="sans-serif">{cell}</text>
              ))}
            </g>
          ))}
        </svg>
      ),
    },
  ];

  return (
    <section className="py-24 bg-cream px-4 sm:px-6 lg:px-8 xl:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-navy text-2xl sm:text-3xl md:text-4xl xl:text-[3rem] leading-[1.2] font-bold mb-4">
            Role-Specific Intelligence for <span className="italic">Transportation Leaders</span>
          </h2>
          <p className="text-charcoal/70 text-lg max-w-2xl mx-auto">Real-time dashboards built for every decision-maker in your transportation organization.</p>
        </div>

        {/* Tab Navigation */}
        <div className="flex flex-wrap gap-3 justify-center mb-10">
          {dashboards?.map((dashboard, index) => (
            <button
              key={index}
              onClick={() => setActiveTab(index)}
              className={`px-6 py-3 rounded-lg font-semibold text-sm transition-all duration-300 ${
                activeTab === index
                  ? 'bg-navy text-white shadow-lg'
                  : 'bg-white text-navy border border-gray-200 hover:border-gold/40 hover:shadow-md'
              }`}
            >
              {dashboard?.title}
            </button>
          ))}
        </div>

        {/* Dashboard Display */}
        <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-200 shadow-lg">
          <div className="mb-4">
            <h3 className="font-serif text-navy text-xl font-bold">{dashboards?.[activeTab]?.title}</h3>
            <p className="text-charcoal/60 text-sm">{dashboards?.[activeTab]?.subtitle}</p>
          </div>
          <div className="w-full aspect-[700/420] rounded-xl overflow-hidden border border-gray-100">
            {dashboards?.[activeTab]?.svg}
          </div>
        </div>
      </div>
    </section>
  );
}
